import React, {useContext} from 'react';
import SettingsContext from "../../contexts/Settings";
import PageContext from "../../contexts/Page";
import {config} from "../../config";

import MenuTop from "../Menu/MenuTop";

//style
import "./Header.scss";

const Header = () => {
	const {scrollY,isHome} = useContext(PageContext);
	const {settingsData} = useContext(SettingsContext);
	const {loga} = settingsData;
	const {domain,domainRelPath} = config

	return (
		<header className="main-header">
			<h1 className={scrollY>0 ? "minified" : "" }>
				<a href={domain+domainRelPath} target="_top" title="Link: Home">
					<img src={isHome? loga.logo_menu : loga.logo_menu_podstrona} alt="Logo Film Poland"/>
				</a>
			</h1>
			<MenuTop/>
		</header>
	);
};


export default Header;

